<div
  class="mainContainer d-flex flex-column align-items-center w-100 position-relative mb-5"
>
  <h3 class="headingBL mb-3">
    <img
      src="assets/images/home/edla.png"
      alt="edla_logo"
      class="align-items-center"
      style="height: 4rem; width: 4rem; margin-right: 1rem"
    />
    EDLA Certified <span> Product</span>
  </h3>
  <p class="vtext Insight_detail text-center px-3 px-md-5">
    At Virsa, we bring you the powerful Panel, combining advanced Virsa hardware
    and software with Google for Education services. Experience a smarter, more
    connected classroom with Virsa.
  </p>

  <div class="container mt-4">
    <div class="row justify-content-center gy-4">
      <div class="col-12 col-sm-6 col-md-4" *ngFor="let item of insight">
        <div
          class="d-flex flex-column align-items-center insightCard h-100 text-center p-3 shadow-sm border rounded"
        >
          <img
            loading="lazy"
            class="cardImage img-fluid mb-3"
            [src]="item.image"
            [alt]="item.name1 + item.name2"
          />
          <div class="card-content">
            <h4 class="headingBL smallHeading">
              {{ item.name1 }} <span>{{ item.name2 }}</span>
            </h4>
            <p class="mt-3 headDetails">
              {{ item.details }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
